module.exports = __webpack_public_path__ + "img/87.b3c41003.jpg";